export default __webpack_public_path__ + "static/media/slantedSunset.428be044.jpg";